export const userColumns = (hideAction?: boolean) => [
  { label: 'Nome', value: 'full_name' },
  { label: 'Responsabilidade', value: 'relation_type' },
  { label: 'Ações', value: 'actions', className: 'w-0', hidden: hideAction },
]
